import { 
  PurchaseLinkService,
} from "../../../shared/services";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Loader,
  ModalComponent,
  RedButton,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import React, { useEffect } from "react";
import { PurchaseLinkModel } from "../../../shared/models";
import styled from "styled-components";
import { set } from "lodash";
import { firstValueFrom } from "rxjs";

type Props = {
  onClose: (deleted: boolean) => void;
  id: string;
};

export const DeleteItemPopupWrapper = styled.div`
  > div {
    /* display: flex; */
    /* align-items: center; */
    margin-bottom: 25px;
    > div > ${CustomLabel} {
      &:first-child {
        margin-right: 10px;
        width: 150px;
      }
      &:last-child {
        flex: 1 1 0;
      }
    }
    .item-icon {
      img {
        height: 20px;
        width: 20px;
      }
    }
  }
`;

const DeletePurchaseLinkPopUp: React.FC<Props> = ({ onClose, id }) => {
  const [data, setData] = React.useState<PurchaseLinkModel | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);

  useEffect(() => {
    loadPurchaseLink();
  }, []);

  const loadPurchaseLink = async () => {
    try {
      const response = await firstValueFrom(
        PurchaseLinkService.getPurchaseLink(AuthService.authData.accountId, id)
      );
      if (response.result) {
        const mappedData = PurchaseLinkModel.deserializeAPIResponse(
          response.result
        );
        setData(mappedData);
      }
    } catch (error) {
      ToastService.showError("Error in loading purchase link");
    } finally {
      setIsLoading(false);
    }
  };

  const row = (
    label: string,
    rightSide: React.ReactNode,
    spacing: number = 20
  ) => {
    return (
      <div>
        <FlexContainer alignItems="center" spacing={spacing}>
          <CustomLabel>{label}</CustomLabel>
          {rightSide}
        </FlexContainer>
      </div>
    );
  };

  function body() {
    return (
      <FlexContainer
        fxLayout="column"
        justifyContent="center"
        alignItems="center"
        spacing={10}
      >
        <CustomLabel style={{ marginBottom: "25px" }}>
          Do you want to{" "}
          <CustomLabel color="#FF0000" fontWeight={600}>
            permanently delete
          </CustomLabel>{" "}
          this Purchase link?
        </CustomLabel>
        {data && (
          <DeleteItemPopupWrapper>
            <>
              {row("Name", <CustomLabel>{data.itemDetails?.name}</CustomLabel>)}
              {row(
                "Created",
                <CustomLabel>
                  {data.createdDate ? data.createdDate.toDateString() : "Never"}
                </CustomLabel>
              )}
              <CustomLabel
                textAlign="center"
                color="red"
                margin="20px 0px 0px"
                className="full-width"
              >
                <span>
                  Purchase Link will be permanently deleted and no longer <br />{" "}
                  be available for new purchases
                </span>
              </CustomLabel>
            </>
          </DeleteItemPopupWrapper>
        )}
      </FlexContainer>
    );
  }

  function onDelete() {
    if (isAPIRequestPending) return;

    setAPIRequestPending(true);
    PurchaseLinkService.deletePurchaseLink(
      AuthService.authData.accountId,
      id
    ).subscribe({
      next: (response) => {
        setAPIRequestPending(false);
        if (response.result) {
          ToastService.showSuccess("Purchase link Deleted Successfully");
          onClose(true);
        }
      },
      error: () => {
        setAPIRequestPending(false);
        ToastService.showError("Error in deleting purchase link");
      },
    });
  }

  return (
    <ModalComponent
      title="Delete Purchase Link"
      titleFontSize="22px"
      bodyPadding="50px 61px"
      showFooter={true}
      minHeight="130px"
      wrapperWidth="550px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      footerHeight="auto"
      redHeader={true}
      blueHeader={false}
      onClose={() => onClose(false)}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            disabled={isAPIRequestPending}
            minWidth="120px"
            height="40px"
            onClick={() => onDelete()}
          >
            Delete
          </RedButton>
          <RedButton
            primary
            minWidth="120px"
            height="40px"
            onClick={() => onClose(false)}
          >
            Do Not Delete
          </RedButton>
        </FlexContainer>
      }
    >
      {isLoading ? new Loader(true).loaderComponent : body()}
    </ModalComponent>
  );
};

export default DeletePurchaseLinkPopUp;
